export default __webpack_public_path__ + "static/media/f1-new-logo.a2893164.png";